var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadplaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 555,
    height: 319,
    viewBox: "0 0 555 319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4490",
    "data-name": "Group 4490",
    transform: "translate(-600 -1042)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8410",
    "data-name": "Rectangle 8410",
    transform: "translate(600 1042)",
    fill: "#18191a",
    stroke: "#636363",
    strokeWidth: 2,
    strokeDasharray: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 555,
    height: 319,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 553,
    height: 317,
    rx: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4479",
    "data-name": "Group 4479",
    transform: "translate(45 1.22)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("text", {
    id: "Drag_and_Drop_Photo",
    "data-name": "Drag and Drop Photo",
    transform: "translate(833 1225)",
    fill: "#fff",
    fontSize: 15,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -71.184,
    y: 0
  }, "Drag and Drop Photo")), /*#__PURE__*/React.createElement("g", {
    id: "upload_2_",
    "data-name": "upload (2)",
    transform: "translate(808 1133.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4472",
    "data-name": "Group 4472",
    transform: "translate(0 18.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46694",
    "data-name": "Path 46694",
    d: "M40.783,30.506A14.526,14.526,0,0,0,13.869,25.68a8.321,8.321,0,0,0-1.526-.144,7.961,7.961,0,0,0-7.95,7.95,8.69,8.69,0,0,0,.165,1.65A11.063,11.063,0,0,0,0,44.056a11.828,11.828,0,0,0,3,7.827,10.71,10.71,0,0,0,7.424,3.733h8.951a1.392,1.392,0,0,0,0-2.784H10.549c-4.217-.258-7.765-4.269-7.765-8.786A8.265,8.265,0,0,1,6.878,36.93a1.4,1.4,0,0,0,.608-1.691,5.051,5.051,0,0,1-.309-1.774A5.175,5.175,0,0,1,12.343,28.3a5.078,5.078,0,0,1,1.763.309,1.4,1.4,0,0,0,1.743-.712,11.74,11.74,0,0,1,22.3,3.867A1.39,1.39,0,0,0,39.308,33,10.035,10.035,0,0,1,38.36,52.82h-7.6a1.392,1.392,0,1,0,0,2.784h7.754a12.337,12.337,0,0,0,8.27-4.083,12.834,12.834,0,0,0-6-21.015Z",
    transform: "translate(0 -18.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46695",
    "data-name": "Path 46695",
    d: "M175.34,195.155a1.388,1.388,0,0,0,0-1.97l-7.373-7.373a1.409,1.409,0,0,0-.98-.412,1.366,1.366,0,0,0-.98.412l-7.373,7.373a1.4,1.4,0,0,0,.98,2.382,1.358,1.358,0,0,0,.98-.412l5-5v22.985a1.392,1.392,0,1,0,2.784,0V190.154l5,5A1.376,1.376,0,0,0,175.34,195.155Z",
    transform: "translate(-141.909 -168.179)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadplaceholder);
export default __webpack_public_path__ + "static/media/uploadplaceholder.b8a75594c52fab844617941e69531836.svg";
export { ForwardRef as ReactComponent };